import type { AutomationDetailTask, AutomationHandoverFlow } from '../../data-contract/automation';

/** Per task, the score's share of its effort goes to software; the rest stays with people. Shares of assessed effort. */
export const itemHandoverFlows = (tasks: readonly AutomationDetailTask[]): AutomationHandoverFlow[] => {
    const flows: AutomationHandoverFlow[] = [];
    let assessedEffort = 0;
    for (const task of tasks) {
        if (task.taskScore == null || task.effortShare == null || task.effortShare <= 0) continue;
        const effort = task.effortShare;
        assessedEffort += effort;
        flows.push(
            { classification: task.classification, destination: 'RELEASED', share: effort * task.taskScore },
            { classification: task.classification, destination: 'RETAINED', share: effort * (1 - task.taskScore) },
        );
    }
    return flows.filter(({ share }) => share > 0).map((flow) => ({ ...flow, share: flow.share / assessedEffort }));
};
